<template>
    <div>
        <div class="simple-form col-2 flex">
            <div class="content-caption dashed">
                <span>返修单信息</span>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>返修单号</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.no}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>服务商</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.servicerName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>业务单元</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.retailerComName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建人</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.creatorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.createTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请状态</label>
                </div>
                <div class="form-value">
                    <span>{{applyStateMap[specificAccVoucherInfo.applyState]}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请人</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.applicantName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请描述</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.applyDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请时间</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.applyTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核状态</label>
                </div>
                <div class="form-value">
                    <span>{{auditStateMap[specificAccVoucherInfo.auditState]}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核人</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.auditorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核描述</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.auditDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核时间</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.auditTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已发货</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.sentFlag ? '已发货' : '待发货'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货标记人</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.sentActorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货备注</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.sentDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货时间</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.sentTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已收货</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.recvFlag ? '已收货' : '待收货'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收货标记人</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.recvActorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收货备注</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.recvDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收货时间</label>
                </div>
                <div class="form-value">
                    <span>{{specificAccVoucherInfo.recvTime}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>返修单项<span class="font-orange">【共{{renterComCount()}}个配件提供商，{{(specificAccVoucherInfo.specificAccRepairItems || []).length}}个配件】</span></span>
        </div>
        <el-table :data="(specificAccVoucherInfo.specificAccRepairItems || []).slice((pageNumber - 1) * pageSize, pageNumber * pageSize)" border style="width: 100%">
            <el-table-column width="200" align="left" prop="srcServicerName" label="服务商"></el-table-column>
            <el-table-column width="200" align="left" prop="srcWarehouseName" label="原出库仓库"></el-table-column>
            <el-table-column width="200" align="left" prop="name" label="配件名称"></el-table-column>
            <el-table-column width="120" align="left" prop="catName" label="分类"></el-table-column>
            <el-table-column width="120" align="left" prop="brandName" label="品牌"></el-table-column>
            <el-table-column width="180" align="left" prop="modelSpec" label="规格"></el-table-column>
            <el-table-column width="150" align="left" prop="vendorSn" label="厂商序列号"></el-table-column>
            <el-table-column width="150" align="left" prop="boundDevcName" label="设备名称"></el-table-column>
            <el-table-column align="left" prop="faultDesc" label="故障说明"></el-table-column>
        </el-table>
        <div class="pagination-layout">
            <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import accStockApi from '../../api/accStock'

    export default{
        name: 'swb-specific-acc-repair-voucher-detail',
        desc: '配件返修单详情',
        props: {
            voucherId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [10, 20, 50, 100, 200],// 特殊页面处理
                //
                specificAccVoucherInfo: {},
                applyStateMap: {},
                auditStateMap: {}
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.applyStateMap = getEnumMap('applyState', 'value2text');
            this.auditStateMap = getEnumMap('auditState', 'value2text');
            this.getSpecificAccVoucherDetail();
        },
        methods: {
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageAccRepairVoucherItemList();
            },
            setPageAccRepairVoucherItemList: function () {
                let totalRows = this.specificAccVoucherInfo.specificAccRepairItems || [];
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                this.pageDeviceImpInfoList = rows;
                this.totalCount = totalRows.length;
            },
            renterComCount: function () {
                let specificAccRepairItems = this.specificAccVoucherInfo.specificAccRepairItems || [];
                let retailerComIds = [];
                for(let i = 0; i < specificAccRepairItems.length; i++) {
                    let devcRentItem = specificAccRepairItems[i];
                    if(!retailerComIds.contains(devcRentItem.renterComId)) {
                        retailerComIds.push(devcRentItem.renterComId);
                    }
                }
                return retailerComIds.length;
            },
            // 查看设备租赁/归还单详情
            getSpecificAccVoucherDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                //
                let msgBoxDlg = MsgBox.loading();
                accStockApi.getSpecificAccRepairVoucherInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let specificAccVoucherInfo = result.data;
                        self.specificAccVoucherInfo = Utils.merge({}, specificAccVoucherInfo);
                        self.setPageAccRepairVoucherItemList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/accStock/SpecificAccRepairVoucherDetail.vue